// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import React from "react";

function Equipment() {
  return <h1>Equipment Page</h1>;
}

export default Equipment;
